import React from "react";
import { Navigate } from "react-router-dom";
import { DefaultLayout } from "../layout";
import { getAuthRoutes } from "../features/auth/routes";
import { getDashboardRoutes } from "../features/dashboard/routes";
import { getErrorRoutes, getDefaultRedirectRoute, getNotFoundRoute } from "../features/errors/routes";
import { getProjectSuperadminRoutes, getProjectAdminOrUserRoutes } from "../features/project/routes";
import { getFunctionSuperadminRoutes } from "../features/function/routes";
import { getUserRoutes } from "../features/user/routes";
import { getConversionsSuperadminRoutes } from "../features/conversions/routes";
import { getBatchReportRoutes } from "../features/batch-report/routes";
import { getReportRoutes } from "../features/report/routes";
import { getRawFileUploadRoutes } from "../features/raw-file-upload/routes";
import { getManageWardsRoutes } from "../features/manage-wards/routes";

export const USER_ROLES = { superadmin: "superadmin", admin: "admin", user: "user" };

const AuthRoutes = getAuthRoutes();

// When already authenticated, /login, /register, /auth should redirect to dashboard (avoids 404 from catch-all)
const authRedirectRoutes = [
  { path: "/login", layout: DefaultLayout, element: <Navigate to="/dashboard" replace /> },
  { path: "/register", layout: DefaultLayout, element: <Navigate to="/dashboard" replace /> },
  { path: "/auth", layout: DefaultLayout, element: <Navigate to="/dashboard" replace /> },
];

const CommonRoutes = [
  getDefaultRedirectRoute(),
  ...getDashboardRoutes(),
  ...getErrorRoutes(),
  ...authRedirectRoutes,
];

const notFoundRoute = getNotFoundRoute();

const SuperadminRoutes = [
  ...CommonRoutes,
  ...getProjectSuperadminRoutes(),
  ...getFunctionSuperadminRoutes(),
  ...getUserRoutes(),
  ...getConversionsSuperadminRoutes(),
  ...getBatchReportRoutes(),
  ...getReportRoutes(),
  ...getRawFileUploadRoutes(),
  ...getManageWardsRoutes(),
  notFoundRoute,
];

const AdminRoutes = [
  ...getProjectAdminOrUserRoutes(),
  ...getBatchReportRoutes(),
  ...getReportRoutes(),
  ...getUserRoutes(),
  ...getRawFileUploadRoutes(),
  ...getManageWardsRoutes(),
  ...CommonRoutes,
  notFoundRoute,
];

const UserRoutes = [
  ...CommonRoutes,
  ...getProjectAdminOrUserRoutes(),
  ...getBatchReportRoutes(),
  ...getReportRoutes(),
  ...getRawFileUploadRoutes(),
  ...getManageWardsRoutes(),
  notFoundRoute,
];

export { AuthRoutes, SuperadminRoutes, AdminRoutes, UserRoutes };
export { CommonRoutes as default };
